interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: 'sm' | 'md' | 'lg';
  showNumber?: boolean;
  detailed?: boolean;
  ratings?: {
    contentQuality: number;
    userExperience: number;
    valueForMoney: number;
    updateSpeed: number;
    safety: number;
  };
}

export default function StarRating({ rating, maxRating = 5, size = 'md', showNumber = true, detailed = false, ratings }: StarRatingProps) {
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  const normalizedRating = (rating / 10) * maxRating;
  const fullStars = Math.floor(normalizedRating);
  const halfStar = normalizedRating - fullStars >= 0.3;
  const emptyStars = maxRating - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <div className={`flex items-center gap-0.5 ${sizeClasses[size]}`}>
          {Array.from({ length: fullStars }).map((_, i) => (
            <i key={`full-${i}`} className="ri-star-fill text-primary-500"></i>
          ))}
          {halfStar && (
            <i className="ri-star-half-line text-primary-500"></i>
          )}
          {Array.from({ length: emptyStars }).map((_, i) => (
            <i key={`empty-${i}`} className="ri-star-line text-foreground-400"></i>
          ))}
        </div>
        {showNumber && (
          <span className="text-sm font-semibold text-primary-500 ml-1">{rating}</span>
        )}
      </div>
      {detailed && ratings && (
        <div className="flex flex-wrap gap-3 mt-1">
          {[
            { label: '内容质量', value: ratings.contentQuality },
            { label: '用户体验', value: ratings.userExperience },
            { label: '性价比', value: ratings.valueForMoney },
            { label: '更新速度', value: ratings.updateSpeed },
            { label: '安全性', value: ratings.safety },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-1 text-xs">
              <span className="text-foreground-400">{item.label}</span>
              <span className="text-foreground-600 font-medium">{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}